import React from 'react';
import Button from '../Button/Button';
import ContentWrapper from '../ContentWrapper';
import SectionContainer from '../SectionContainer';

export default function DownloadFile({ data }) {
  return (
    <SectionContainer backgroundColor="white" className="download-file">
      <ContentWrapper>
        <div className="download-file-container">
          <div className="download-file-text">
            <h3 className="download-file-title colored-title">{data.title}</h3>
            <p className="download-file-description">
              {data.downloadDescription}
            </p>
          </div>
          <div className="download-button">
            <a href={data.button.url} rel="noopener noreferrer" target="_blank">
              <Button buttonStyle={data.button.buttonStyle}>
                {data.button.text}
              </Button>
            </a>
          </div>
        </div>
      </ContentWrapper>
    </SectionContainer>
  );
}
